import { useState } from "react";
import { Button, Modal } from "@monolith-forensics/monolith-ui";
import ButtonMenu from "../Forms/components/ButtonMenu.js";
import { usePermissions } from "../../hooks/usePermissions";
import LoggingAPI from "../../api/logging/index.js";
import ForensicSoftwareAPI from "../../api/software/index.js";
import { ForensicSoftware } from "@/types/index.js";
import { SoftwareFormData } from "../Forms/DefaultSoftwareForm.js";
import UserGroupsAPI from "@/api/users/groups.js";
import { useTheme } from "styled-components";

interface DeleteGroupModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (defaultInfo?: any) => void;
  onCancel: () => void;
  buttonProps?: {
    cancelText: string;
    submitText: string;
  };
  defaultInfo?: any;
}

const DeleteGroupModal: React.FC<DeleteGroupModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  buttonProps,
  defaultInfo,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const { currentUser } = usePermissions();
  const theme: any = useTheme();

  const handleSubmit = async () => {
    setSubmitting(true);

    await UserGroupsAPI.delete({
      uuid: defaultInfo.uuid,
    });

    LoggingAPI.createLog({
      user_id: currentUser.user_id,
      message: `Deleted User Group: ${defaultInfo?.name}`,
      event: "user_group:delete",
      object_type: "user_group",
    });

    onSubmit?.(defaultInfo);
    setSubmitting(false);
    onClose?.();
  };

  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <Modal.Title>Delete User Group</Modal.Title>
      <div style={{ fontWeight: 600, margin: "20px 0px" }}>
        Are you sure you want to delete this User Group?
      </div>
      <div style={{ fontSize: "0.75rem", fontWeight: 500, display: "flex" }}>
        <div
          style={{
            width: 75,
            color: theme.palette.text.secondary,
            fontWeight: 500,
          }}
        >
          Group
        </div>
        <div style={{}}>{defaultInfo.name}</div>
      </div>
      <div style={{ fontSize: "0.75rem", fontWeight: 500, display: "flex" }}>
        <div
          style={{
            width: 75,
            color: theme.palette.text.secondary,
            fontWeight: 500,
          }}
        >
          Users
        </div>
        <div style={{}}>{defaultInfo.users.length}</div>
      </div>
      <ButtonMenu>
        <Button
          size="xs"
          variant="subtle"
          onClick={handleCancel}
          disabled={submitting}
        >
          {buttonProps?.cancelText || "Cancel"}
        </Button>
        <Button
          size="xs"
          color="error"
          variant="contained"
          onClick={handleSubmit}
          disabled={submitting}
          loading={submitting}
        >
          {buttonProps?.submitText || "Delete User Group"}
        </Button>
      </ButtonMenu>
    </Modal>
  );
};

export default DeleteGroupModal;
